export default __webpack_public_path__ + "static/media/resizedFAMSLogo.55fc96b8.png";